import { curry, path } from "ramda"
import { isString, isNotNullOrEmpty, isNotEmptyString } from "../../validate"
import { isChineseInputText, charsForStartForbid, isInputText } from "./specialChecking"

export default curry((maxLength, { value: str, forminputdata }) => {
  const countryCode = isNotNullOrEmpty(forminputdata) ? path(["region", "country", "id"], forminputdata) : ""

  if (countryCode !== "HKG") {
    if (!isInputText(str)) return false
    if (maxLength && (str.length <= 0 || str.length > maxLength)) return false
  }

  return true
})
